<template>
  <div class="list-empty">
    <img alt="" :src="aiLogo" />
    <div v-if="mainTitle" class="main-title">{{ mainTitle }}</div>
    <div class="text">{{ title }}</div>
    <slot name="action"></slot>
  </div>
</template>

<script setup>
import aiLogo from '@/assets/ai-logo-empty.png'

defineProps({
  title: {
    type: String,
    default: '暂无符合条件的销售机会'
  },
  mainTitle: {
    type: String,
    default: ''
  }
})
</script>

<style lang="scss" scoped>
.list-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1;
  img {
    // width: 73px;
    height: 112px;
    margin-bottom: 16px;
  }
  .text {
    font-family: PingFang SC;
    font-size: 14px;
    line-height: 20px;
    color: #969799;
    white-space: pre-line;
    text-align: center;
  }
  .main-title {
    font-family: PingFang SC;
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
    color: #323233;
  }
}
</style>
